import React, { ReactNode } from "react";

import { Box, ColumnContainer } from "app/layout/components";
import { QuickSearchFieldContainer } from "app/search/QuickSearchFieldContainer/QuickSearchFieldContainer";
import { defaultMetaData } from "app/main/siteMetaData";
import { StreamList } from "app/stream/StreamList/StreamList";
import { StreamListItemProps } from "app/stream/StreamListItem/StreamListItem";
import { PageBase } from "app/layout/PageBase/PageBase";
import { AdContainer } from "app/thirdParty/ads/AdContainer";
import { AdTypes } from "app/thirdParty/ads/interfaces";
import { DataProviderContext } from "app/main/DataProvider";
import { BreadcrumbsContainer } from "app/breadcrumbs/BreadcrumbsContainer";

interface Props {
    breadcrumbFinalLabel?: string;
    metaData?: { [name: string]: string };
    title?: string;
    canonicalUrl?: string;
    streamListItems?: StreamListItemProps[];
    children: ReactNode;
}

/**
 * This component provides the page wrapper that is used by most pages.
 * The raw skeleton taken from PageBase but decorated with Breadcrumbs and the QuickSearch.
 */
export const Page = ({
    canonicalUrl,
    breadcrumbFinalLabel,
    metaData = defaultMetaData,
    title,
    streamListItems,
    children
}: Props) => {
    const {
        config: { marketOverViewUrl }
    } = React.useContext(DataProviderContext);

    return (
        <PageBase metaData={metaData} title={title} canonicalUrl={canonicalUrl}>
            <AdContainer type={[AdTypes.BILLBOARD]} containerId="Tcb" />
            <ColumnContainer spacing={0}>
                <BreadcrumbsContainer finalLabel={breadcrumbFinalLabel} />
            </ColumnContainer>
            <Box className={"quicksearchBox"}>
                <QuickSearchFieldContainer />
                {streamListItems && streamListItems.length && (
                    <StreamList
                        items={streamListItems}
                        linkButtonUrl={marketOverViewUrl}
                        linkButtonTitle={"Marktüberblick"}
                    />
                )}
            </Box>
            {children}
            <AdContainer type={[AdTypes.STICKY_MOBILE_FOOTER]} />
        </PageBase>
    );
};
